import { configureStore } from "@reduxjs/toolkit";
import { composeWithDevTools } from "@redux-devtools/extension";
import counterReducer from "./slices/counter";
import user from "./slices/user";
import jobs from "./slices/jobs";
import customers from "./slices/customers";
import projects from "./slices/projects";
import logs from "./slices/logs";
import slings from "./slices/slings";
import kanban from "./slices/kanban";
import forms from "./slices/forms";
import materials from "./slices/materialsSlice";
import pipeSpecs from "./slices/pipeSpecsSlice";
import calculator from "./slices/calculatorSlice";
import trello from "./slices/trello";
import users from "./slices/users";
import uttReference from "./slices/uttReference";
import uttLogs from "./slices/uttLogs";
import ncReports from "./slices/ncReports";
import rebuildLogs from "./slices/rebuildLogs";
import rebuildScans from "./slices/rebuildScans";

export const store = configureStore(
  {
    reducer: {
      counter: counterReducer,
      user,
      customers,
      jobs,
      projects,
      logs,
      slings,
      kanban,
      materials,
      pipeSpecs,
      calculator,
      forms,
      trello,
      users,
      uttReference,
      uttLogs,
      ncReports,
      rebuildLogs,
      rebuildScans,
    },
  },
  composeWithDevTools()
);
